module.exports = __webpack_public_path__ + "static/media/Griffin.23f458fb.png";